var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-route-edit-modal"},[_c('md-dialog',{ref:"dialog"},[_c('site-route-edit',{attrs:{"siteId":_vm.siteId},on:{"saved":_vm.saved}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }